    document.addEventListener("DOMContentLoaded", function () {
        const videoButtons = document.querySelectorAll(".video-button");
        const videoPopup = document.getElementById("videoPopup");
        const videoPlayer = document.getElementById("videoPlayer");
        const closeButton = document.querySelector(".popup .close");

        // Open the popup and load the video
        videoButtons.forEach((button) => {
            button.addEventListener("click", function () {
                const videoUrl = this.getAttribute("data-video");
                videoPlayer.src = videoUrl;
                videoPopup.style.display = "block";
                videoPlayer.play();
            });
        });

        // Close the popup
        closeButton.addEventListener("click", function () {
            videoPopup.style.display = "none";
            videoPlayer.pause();
            videoPlayer.src = ""; // Clear the video source
        });

        // Close popup when clicking outside the content
        window.addEventListener("click", function (e) {
            if (e.target === videoPopup) {
                videoPopup.style.display = "none";
                videoPlayer.pause();
                videoPlayer.src = ""; // Clear the video source
            }
        });
    });